<template>
  <section class="content">
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4><i :class="alert.icon"></i>{{`alert_${alert.type}` | translate}}!</h4>{{alert.message}}
      </b-alert>
    </template>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h2 class="box-title"><i class="fa fa-newspaper-o mr-5"></i>{{'notifications' | translate}}</h2>
      </div>
      <div class="box-controls">
        <div class="row">
          <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
        </div>
      </div>
      <div class="box-body">
        <template v-if="loading">
          <div class="row">
            <div class="col-xs-12 text-center">
              <img class="loading-gif" src="/static/img/blabla.svg"/>
            </div>
          </div>
        </template>
        <template v-else>
          <news-table :notifications="pagination.data" @edit="edit($event, value)"></news-table>
        </template>
      </div>
      <div class="box-footer">
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
      </div>
    </div>
  </section>
</template>
<script>
import NewsTable from '@/components/tools/Tables/NewsTable.vue'
export default {
  name: 'ListNews',
  data () {
    return {
      alerts: [],
      loading: false,
      value: '',
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0,
        data: []
      }
    }
  },
  components: {
    newsTable: NewsTable
  },
  methods: {
    paginate (type, value) {
      this.loading = true
      let url = '?preflight=kek'
      if (type === 'page') {
        url += '&page='
        if (value === 'previous') {
          url += (this.pagination.current_page - 1)
        }
        if (value === 'next') {
          url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
        } else if (value !== 'next' && value !== 'previous') {
          url += value
        }
      }
      API.get('messages/listNews' + url)
        .then(response => {
          this.pagination = response.data
          if (typeof response.data.data !== 'undefined' || response.data.data.length !== 0) {
            this.pagination.data.forEach((note) => {
              note.icon = note.status === 'info' ? 'fa fa-info-circle' : 'fa fa-warning'
              note.original_message = note.message
              note.message = note.message.split('\n')
            })
          }
          this.loading = false
        })
        .catch(error => {
          if (this.$store.dispatch('checkError', error)) {
            let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
            this.alerts.push(alert)
          } else this.$router.push('/unauthorized')
        })
    },
    edit (data) {
      let alert
      data.is_active = data.is_active ? 0 : 1
      data.message = data.original_message
      API.put('messages/' + data.id, data)
        .then(() =>  {
          alert = {dismiss: 4, type: 'success', message: 'Update Successful', icon: 'icon fa fa-check', show: true}
          this.alerts.push(alert)
          this.getMessages()
        })
        .catch(error => {
          alert = {dismiss: 4, type: 'danger', message: 'There was an error: ' + error.body.message, icon: 'icon fa fa-ban', show: true}
          this.alerts.push(alert)
        })
    },
    getMessages () {
      this.notifications = []
      API.get('messages')
        .then(response => {
          if (typeof response.data !== 'undefined' || response.data.length !== 0) {
            response.data.forEach(function (note) {
              note.icon = note.status === 'info' ? 'fa fa-info-circle' : 'fa fa-warning'
              note.original_message = note.message
              note.message = note.message.split('\n')
              this.notifications.push(note)
            })
          }
        })
    }
  },
  mounted () {
    this.paginate()
  }
}
</script>
<style scoped>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/ListNews.vue